import { render, staticRenderFns } from "./IntroduceTeachers.vue?vue&type=template&id=314eac36&scoped=true&"
import script from "./IntroduceTeachers.vue?vue&type=script&lang=js&"
export * from "./IntroduceTeachers.vue?vue&type=script&lang=js&"
import style0 from "./IntroduceTeachers.vue?vue&type=style&index=0&id=314eac36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314eac36",
  null
  
)

export default component.exports